import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { ID } from '@common/interfaces/id';
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class UserApiService {
  constructor(private http: HttpClient) {}

  getOloNetworksByUserId$(userId: ID): Observable<{ olo: string; network: string }[]> {
    return this.http.get<{ olo: string; network: string }[]>(
      `${environment.apiUrl}/api/user/${userId}/oloNetworks`
    );
  }

  getOloNetworksByUsersIds(userIds: ID[]): Observable<{[userId: ID]: { olo: string; network: string }[]}> {
    return this.http.post<{[userId: ID]: { olo: string; network: string }[]}>(
      `${environment.apiUrl}/api/user/oloNetworks/by-ids`, { userIds }
    );
  }

}
